import React, { useEffect, useState } from 'react';
import { CalendarDays, MapPin, Clock, ExternalLink, Heart, Users } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const money = (n) => `$${Math.round(n).toLocaleString('en-US')}`;

export function ImpactCounter() {
  const [d, setD] = useState(null);
  useEffect(() => { fetch(`${API}/sponsor/impact`).then((r) => r.json()).then(setD).catch(() => {}); }, []);
  if (!d || (!d.raised && !d.kids)) return null;
  return (
    <section className="pb-12" data-testid="sponsor-impact-counter">
      <div className="max-w-6xl mx-auto px-6">
        <div className="rounded-3xl bg-splash-green text-white p-6 md:p-8 grid sm:grid-cols-2 gap-6">
          <div className="flex items-center gap-4">
            <Heart className="w-10 h-10 text-splash-coral shrink-0" />
            <div><div className="font-display font-bold text-4xl md:text-5xl" data-testid="impact-raised">{money(d.raised)}</div><div className="text-sm text-splash-cream/75 uppercase tracking-widest">raised so far</div></div>
          </div>
          <div className="flex items-center gap-4">
            <Users className="w-10 h-10 text-splash-coral shrink-0" />
            <div><div className="font-display font-bold text-4xl md:text-5xl" data-testid="impact-kids">{d.kids}</div><div className="text-sm text-splash-cream/75 uppercase tracking-widest">kids sponsored</div></div>
          </div>
        </div>
      </div>
    </section>
  );
}

export function EventCalendar() {
  const [events, setEvents] = useState(null);
  useEffect(() => { fetch(`${API}/sponsor/events`).then((r) => r.json()).then((d) => setEvents(d.events || [])).catch(() => setEvents([])); }, []);
  return (
    <section className="py-16" data-testid="sponsor-events">
      <div className="max-w-4xl mx-auto px-6">
        <div className="uppercase tracking-widest text-splash-coral text-xs font-semibold mb-3">Hope Floats Events</div>
        <h2 className="font-display font-bold text-3xl md:text-4xl text-splash-green">Upcoming events</h2>
        <div className="mt-8 space-y-3">
          {events === null ? null : events.length === 0 ? (
            <div className="rounded-3xl bg-white border border-splash-sand p-6 text-splash-green/75" data-testid="sponsor-events-empty">New events are posted monthly — check back soon!</div>
          ) : events.map((ev) => {
            const dt = new Date(`${ev.date}T12:00:00`);
            return (
              <div key={ev.id} className="rounded-3xl bg-white border border-splash-sand p-5 flex gap-5" data-testid={`sponsor-event-${ev.id}`}>
                <div className="shrink-0 w-16 h-16 rounded-2xl bg-splash-coral text-white grid place-items-center text-center leading-none">
                  <div><div className="text-xs uppercase">{dt.toLocaleDateString('en-US', { month: 'short' })}</div><div className="font-display font-bold text-2xl">{dt.getDate()}</div></div>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="font-display font-bold text-xl text-splash-green">{ev.title}</div>
                  <div className="mt-1 flex flex-wrap gap-x-4 gap-y-1 text-sm text-splash-green/70">
                    <span className="inline-flex items-center gap-1"><CalendarDays className="w-4 h-4" /> {dt.toLocaleDateString('en-US', { weekday: 'long' })}</span>
                    {ev.time && <span className="inline-flex items-center gap-1"><Clock className="w-4 h-4" /> {ev.time}</span>}
                    {ev.location && <span className="inline-flex items-center gap-1"><MapPin className="w-4 h-4" /> {ev.location}</span>}
                  </div>
                  {ev.description && <p className="mt-2 text-sm text-splash-green/80">{ev.description}</p>}
                  {ev.link && <a href={ev.link} target="_blank" rel="noreferrer" className="mt-2 inline-flex items-center gap-1 text-sm font-semibold text-splash-teal">Details <ExternalLink className="w-3.5 h-3.5" /></a>}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
